import {observer} from 'mobx-react';
import React from 'react';
import {TooltipSpan} from '../../../../../../lib/components';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {GapItem, TextItem} from '../../models';
import {GapFillingEditStore} from '../GapFillingEditStore';
import {ErrorItem} from '../models';

function renderItem(item: GapItem | TextItem | ErrorItem, key: string | number) {
  if (item.type === 'text')
    return (<span className="text" key={key}>{item.content}</span>);

  if (item.type === 'gap-error')
    return (
      <span className="bg-danger border-danger gap invalid" key={key}>
        {item.message}
      </span>
    );

  if (item.type === 'gap') {
    const placeholder = item.placeholder === ''
      ? '_'.repeat(item.value.length)
      : item.placeholder;

    return (
      <TooltipSpan className="bg-success border-success gap valid" key={key}
                   tooltipText={item.value}>
        {placeholder}
      </TooltipSpan>);
  }
  return null;
}

function* renderer(store: GapFillingEditStore): ReactNodeGenerator {
  const model = store.model;

  for (let index = 0; index < model.paragraphs.length; index++) {
    let paragraph = model.paragraphs[index];

    yield (
      <p key={index} className="gap-filling-paragraph">
        {
          paragraph.items.map((item, index) => renderItem(item, index))
        }
      </p>);
  }

  if (store.gaps.length === 0)
    yield (
      <div className="alert alert-info" key="no-gaps">No gap items</div>
    );
}

@observer
export class GapFillingPreview extends React.Component<{ store: GapFillingEditStore }> {
  render() {
    return (
      <div className="row">
        <div className="col">
          {Array.from(renderer(this.props.store))}
        </div>
      </div>
    );
  }
}
